export default __webpack_public_path__ + "static/media/infinite.7fc0897d.svg";